import 'whatwg-fetch'

import { createRoot } from 'react-dom/client'
import { App } from './components/App/App'
import * as serviceWorker from './serviceWorker'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  root.render(<App />)
} else {
  console.error('Root container not found')
}

serviceWorker.unregister()
